<template>
  <v-app-bar v-if="loggedIn" color="deep-purple" dark short app>
    <v-spacer></v-spacer>
    <v-btn @click="logout">Logout</v-btn>
  </v-app-bar>
</template>
<script>
import gql from "graphql-tag";
export default {
  apollo: {
    $client: "b"
  },
  computed: {
    loggedIn() {
      return this.$store.state.loggedIn;
    }
  },
  methods: {
    logout() {
      let logoutMutation = gql`
        mutation logout {
          logout {
            success
          }
        }
      `;
      this.$apollo
        .mutate({
          mutation: logoutMutation
        })
        .then(({ data }) => {
          if (data.logout && data.logout.success) {
            this.$store.commit({ type: "logIn", loggedIn: false });
            this.$router.push("/");
          }
        })
        .catch(e => console.log(e));
    }
  }
};
</script>